import { booleanPointInPolygon } from "@turf/boolean-point-in-polygon";

// Function to check if coordinates are in water using OpenStreetMap Nominatim API
export async function isPointInWater(latitude: number, longitude: number) {
    try {
        // Using OpenStreetMap's Nominatim API for reverse geocoding
        const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?` +
            `format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=0&layer=natural&polygon_geojson=1`,
            {
                headers: {
                    'Accept': 'application/json',
                    // Add a meaningful User-Agent as requested by OSM
                    'User-Agent': 'WaterLocationChecker/1.0'
                }
            }
        );

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();

        // Check various properties that might indicate water
        const isMaybeWater = Boolean(
            // Check if the location is explicitly tagged as water
            data.address?.water ||
            data.address?.bay ||
            data.address?.strait ||
            data.address?.river ||
            data.address?.lake ||
            data.address?.ocean ||
            data.address?.sea ||
            // Check the class/type of the location
            data.class === 'water' ||
            data.type === 'water' ||
            data.type === 'bay' ||
            data.type === 'strait' ||
            data.type === 'river' ||
            data.type === 'lake' ||
            data.type === 'ocean'
        );

        const isWay = Boolean(
            data.osm_type === 'way'
        );

        const isRelation = Boolean(
            data.osm_type === 'relation'
        );

        let isWater = isMaybeWater && !isWay && isRelation;

        if (isWater) {
            // We still need to check exact match for water polygon
            // returned by nominatim
            const polygon = data.geojson;
            const point = {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [longitude, latitude]
                }
              };
            const isInside = booleanPointInPolygon(point, polygon);
            isWater = isInside;
        }

        return {
            isWater,
            details: data,
            error: false
        };
    } catch (error) {
        console.error('Error checking water location:', error);
        return {
            isWater: false,
            details: {},
            error: true
        };
    }
}